// extracted by mini-css-extract-plugin
module.exports = {"title":"CustomerInfo_title__3IcVt","dataPiece":"CustomerInfo_dataPiece__xsCK4"};